import { defineMessages } from "react-intl";

export const messages = defineMessages({
  alertWarningText: {
    id: "alert.warning.modifyParticipants.text",
    defaultMessage:
      "All users added to the meeting have access to all shared information. If you remove a user, their access to the shared information will be revoked. Please ensure that no important users are removed by mistake.",
    description: "Warning of before updating participants",
  },
});
